// Column sizing (min/max width + wrapping) is owned entirely by MTCommonTable.
// Do not add hardcoded width/minWidth/maxWidth here.
export const MT_TIN_COLUMNS = [
  { id: 'countryName', label: 'Country' },

  {
    id: 'entityName',
    label: 'Entity name',
  },
  {
    id: 'uniqueIdentificationNumber',
    label: 'Unique identification number',

    isFormatted: false,
  },
  {
    id: 'taxIdentificationNumber',
    label: 'Tax identification number',

    isFormatted: false,
  },
  {
    id: 'createdBy',
    label: 'Created by',
  },
  {
    id: 'createdDate',
    label: 'Created date',
  },
  {
    id: 'lastModifiedBy',
    label: 'Updated by',
  },
  {
    id: 'lastModifiedDate',
    label: 'Updated date',
  },
]
